<div class="card-body">
    <ul class="nav nav-tabs border-tab border-0 mb-0 nav-primary" id="topline-tab" role="tablist">
        <li class="nav-item"><a class="nav-link nav-border txt-success nav-success" id="topline-top-service-events-tab"
                                [class.active]="tab === 'service-events'" (click)="changeTab('service-events')"><i
                class="icofont icofont-meeting-add"></i>Eventos</a></li>
        <li class="nav-item"><a class="nav-link nav-border txt-danger nav-danger" id="topline-top-canceled-events-tab"
                                [class.active]="tab === 'canceled-events'" (click)="changeTab('canceled-events')"><i
                class="icofont icofont-ui-block"></i>Cancelados</a></li>
    </ul>
</div>
<div class="tab-content" id="topline-tabContent">
    <div class="tab-pane fade" id="topline-top-service-events" [ngClass]="{'show active': tab === 'service-events' }">
        <div class="card-body px-0 pb-0 pt-3">
            <div class="user-content">
                <ng-container #containerActiveEvents></ng-container>
            </div>
        </div>
    </div>
    <div class="tab-pane fade" id="topline-top-canceled-events" [ngClass]="{'show active': tab === 'canceled-events' }">
        <div class="card-body px-0 pb-0 pt-3">
            <div class="user-content">
                <ng-container #containerCanceledEvents></ng-container>
            </div>
        </div>
    </div>
</div>
